import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ServiceCompleted from "../../Modals/servicecompleted";
const ViewServiceDetails: React.FC = () => {
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    // Static service booking data
    const booking = {
        id: "BK12345",
        customerName: "John Doe",
        customerPhone: "123-456-7890",
        bookingDateTime: "2025-11-19 14:30",
        amount: "250.00",
        paymentMethod: "Credit Card",
        paymentStatus: "Paid",
        adminCommission: 20,
        netPayout: 230,

        // Vendor Details
        vendor: {
            name: "Vendor John",
            email: "vendorjohn@mail.com",
            phone: "9876543210",
            image: "/static/images/user_placeholder.png",
        },

        // Service Details (single or multiple)
        services: [
            {
                name: "AC Repair Service",
                description: "Complete inspection and repair of home air conditioners.",
                price: "250.00",
                image: "/static/images/placeholder.png",
            },
        ],

        // Activity Log
        activityLog: [
            { time: "2025-11-19 14:35", action: "Booking created", actor: "Vendor" },
            { time: "2025-11-19 15:00", action: "Booking Accepted", actor: "Service Provider" },
        ],
    };

    return (
        <><div className="view_order_page">
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1>View Service Booking</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                        <button onClick={() => navigate("/order-management")}>
                            Service Management
                        </button>{" "}
                        - View
                    </p>
                </div>
                <div className="right_s">
                    <Button className="btn btn_primary" onClick={() => setOpenModal(true)}><DoneAllIcon />Mark as completed</Button>
                </div>
            </div>

            {/* Booking Summary */}
            <div className="cards view_page">
                <h3>Booking Details</h3>
                <div className="gap_p">
                    <div className="w_33">
                        <h6>Booking ID</h6>
                        <p>{booking.id}</p>
                    </div>
                    <div className="w_33">
                        <h6>Booking Date & Time</h6>
                        <p>{booking.bookingDateTime}</p>
                    </div>

                    <div className="w_33">
                        <h6>Payment Method</h6>
                        <p>{booking.paymentMethod}</p>
                    </div>

                    <div className="w_33">
                        <h6>Payment Status</h6>
                        <p>{booking.paymentStatus}</p>
                    </div>

                    <div className="w_33">
                        <h6>Total Amount</h6>
                        <p>${booking.amount}</p>
                    </div>

                    <div className="w_33">
                        <h6>Admin Commission</h6>
                        <p>{booking.adminCommission}%</p>
                    </div>

                    <div className="w_33">
                        <h6>Net Payout</h6>
                        <p>${booking.netPayout}</p>
                    </div>
                </div>
            </div>

            {/* Vendor Details */}
            <div className="cards view_page">
                <h3>Vendor Details</h3>
                <div className="gap_p view_page">
                    <div className="w_100 vew_img">
                        <h6>Vendor Image</h6>
                        <figure>
                            <img src={booking.vendor.image} alt="" />
                        </figure>
                    </div>

                    <div className="w_33">
                        <h6>Vendor Name</h6>
                        <p>{booking.vendor.name}</p>
                    </div>

                    <div className="w_33">
                        <h6>Vendor Email</h6>
                        <p>{booking.vendor.email}</p>
                    </div>

                    <div className="w_33">
                        <h6>Vendor Phone</h6>
                        <p>{booking.vendor.phone}</p>
                    </div>
                </div>
            </div>

            {/* Service Details */}
            <div className="cards">
                <CardContent>
                    <h3>Service Details</h3>
                    <Grid container spacing={2}>
                        {booking.services?.map((service, idx) => (
                            <Grid item xs={12} md={6} key={idx}>
                                <Card variant="outlined" sx={{ display: "flex", padding: 1 }}>
                                    <Box sx={{ width: 100, height: 100, mr: 2 }}>
                                        <img
                                            src={service.image}
                                            alt={service.name}
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                    </Box>
                                    <Box>
                                        <Typography variant="subtitle1">{service.name}</Typography>
                                        <Typography variant="body2">
                                            {service.description}
                                        </Typography>
                                        <Typography variant="body2">
                                            Price: ${service.price}
                                        </Typography>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </div>

            {/* Activity Log */}
            <div className="cards view_page">
                <h3>Activity Log</h3>
                {booking.activityLog?.length ? (
                    <ul>
                        {booking.activityLog.map((log, idx) => (
                            <li key={idx}>
                                <strong>{log.time}</strong>: {log.action} ({log.actor})
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No activity recorded.</p>
                )}
            </div>
            <div className="cards view_page">
                <h3>Vendor rejected your submission</h3>
                <h3>Reason:-</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Non voluptate consequuntur minima maiores expedita soluta vitae. Reiciendis amet recusandae, ipsam non neque veritatis animi unde exercitationem dolore necessitatibus aspernatur ducimus.</p>
                <div className="mt_20">
                <Button onClick={() => setOpenModal(true)} className="btn btn_primary">Submit Again</Button>
            </div></div>
        </div><ServiceCompleted
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal} /></>
    );
};

export default ViewServiceDetails;
